import config from "@/config"
import http from "@/utils/request"


// export function getList(data) {
//     return http.get(`${config.API_URL}/api/app/ware-house`, data)
// }

export default {
    getList: {
        url: `${config.API_URL}/api/app/ware-house`,
        name: "获取列表",
        get: async function (params) {
            return await http.get(this.url, params);
        }
    },
    getListByEnable: {
        url: `${config.API_URL}/api/app/ware-house/by-is-enable`,
        name: "获取仓库启用列表",
        get: async function (params) {
            return await http.get(this.url, params);
        }
    },
    getListByWareHouseNames: {
        url: `${config.API_URL}/api/app/ware-house/by-ware-house-names`,
        name: "获取账号下所有仓库，分组后的结果",
        get: async function (params) {
            return await http.get(this.url, params);
        }
    },
    getListByWareHouseIsEnable: {
        url: `${config.API_URL}/api/app/ware-house/by-ware-house-is-enable`,
        name: "获取账号下所有仓库，分组后的结果，根据启用状态",
        get: async function (params) {
            return await http.get(this.url, params);
        }
    },
    getPageListProductInventory: {
        url: `${config.API_URL}/api/app/ware-house/page-list-ware-house-inventory`,
        name: "获取仓库库存列表接口",
        get: async function (params) {
            return await http.get(this.url, params);
        }
    },
    getPageList: {
        url: `${config.API_URL}/api/app/ware-house/page-list`,
        name: "获取仓库分页列表",
        get: async function (params) {
            return await http.get(this.url, params);
        }
    },
    updateIsEnable: {
        url: `${config.API_URL}/api/app/ware-house/update-is-enable`,
        name: "修改是否启用仓库",
        post: async function (params) {
            return await http.post(this.url, params);
        }
    },
    update: {
        url: `${config.API_URL}/api/app/ware-house/update`,
        name: "修改本地仓库名称",
        post: async function (params) {
            return await http.post(this.url, params);
        }
    },
    syncWareHouseProductSku: {
        url: `${config.API_URL}/api/app/ware-house-service-provider/sync-ware-house-product`,
        name: "同步仓库SKU",
        post: async function (params) {
            return await http.post(this.url, params);
        }
    },
    getWareHouseServiceProvider: {
        url: `${config.API_URL}/api/app/ware-house-service-provider`,
        name: "获取仓库账号配置列表",
        get: async function (params) {
            return await http.get(this.url, params);
        }
    },
    syncWareHouseProductInventoryt: {
        url: `${config.API_URL}/api/app/ware-house-service-provider/sync-ware-house-produc-inventoryt`,
        name: "同步SKU库存",
        post: async function (params) {
            return await http.post(this.url, params);
        }
    },
    getWareHouseSkuPageList: {
        url: `${config.API_URL}/api/app/ware-house-sku/page-list`,
        name: "获取仓库SKU列表",
        get: async function (params) {
            return await http.get(this.url, params);
        }
    },
    pair: {
        url: `${config.API_URL}/api/app/ware-house-sku/pair`,
        name: "单个配对",
        post: async function (params) {
            return await http.post(this.url, params);
        }
    },
    fullPair: {
        url: `${config.API_URL}/api/app/ware-house-sku/full-pair`,
        name: "整箱配对",
        post: async function (params) {
            return await http.post(this.url, params);
        }
    },
    removePair: {
        url: `${config.API_URL}/api/app/ware-house-sku/pair`,
        name: "移除配对",
        delete: async function (params) {
            return await http.delete(this.url, params);
        }
    },
    autoPair: {
        url: `${config.API_URL}/api/app/ware-house-sku/auto-pair`,
        name: "自动配对",
        post: async function (params) {
            return await http.post(this.url, params);
        }
    },
    skuGetPageListProductInventory: {
        url: `${config.API_URL}/api/app/ware-house-sku/page-list-product-inventory`,
        name: "获取产品库存列表",
        get: async function (params) {
            return await http.get(this.url, params);
        }
    },
    amazonWareHouseCreate: {
        url: `${config.API_URL}/api/app/amazon-ware-house`,
        name: "亚马逊仓库创建配对",
        post: async function (params) {
            return await http.post(this.url, params);
        }
    },
    amazonWareHouseGetPageList: {
        url: `${config.API_URL}/api/app/amazon-ware-house/page-list`,
        name: "获取亚马逊仓库配对分页列表",
        get: async function (params) {
            return await http.get(this.url, params);
        }
    },
    amazonWareUpdateIsEnable: {
        url: `${config.API_URL}/api/app/amazon-ware-house/update-is-enable`,
        name: "亚马逊仓库配对是否启用",
        post: async function (params) {
            return await http.post(this.url, params);
        }
    },
    amazonWareUpdate: {
        url: `${config.API_URL}/api/app/amazon-ware-house`,
        name: "修改亚马逊仓库配置",
        put: async function (params) {
            return await http.put(this.url, params);
        }
    },
    getAmazonWareSkuMapByAmazonWareHouseId: {
        url: `${config.API_URL}/api/app/amazon-ware-house-sku-map/`,
        name: "获取亚马逊仓库SKU映射列表",
        get: async function (params) {
            return await http.get(this.url + params);
        }
    },
    addAmazonWareSkuMap: {
        url: `${config.API_URL}/api/app/amazon-ware-house-sku-map`,
        name: "创建亚马逊仓库映射",
        post: async function (params) {
            return await http.post(this.url, params);
        }
    },
    thirdPartyServiceProvider: {
        getList: {
            url: `${config.API_URL}/api/app/third-party-service-provider`,
            name: "获取第三方服务商列表",
            get: async function (params) {
                return await http.get(this.url, params);
            }
        }
    }
}
